export type RoleType = 'admin' | 'moderator' | 'user';

export interface RoleStyle {
  badge: string;
  border: string;
  icon: string;
  label: string;
  glow: string;
  textColor: string;
}

/**
 * Retorna estilos visuais baseados na role do usuário
 * Design mobile-first com cores do design system
 */
export const getRoleStyle = (role: RoleType): RoleStyle => {
  switch (role) {
    case 'admin':
      return {
        badge: 'bg-gradient-to-r from-red-600 to-yellow-600 text-white font-bold',
        border: 'border-2 border-red-500/50',
        icon: '🛡️',
        label: 'ADMINISTRADOR',
        glow: 'shadow-lg shadow-red-500/30',
        textColor: 'text-red-400'
      };
    
    case 'moderator':
      return {
        badge: 'bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold',
        border: 'border-2 border-blue-500/50',
        icon: '⭐',
        label: 'MODERADOR',
        glow: 'shadow-lg shadow-blue-500/30',
        textColor: 'text-blue-400'
      };
    
    case 'user':
    default:
      return {
        badge: 'bg-white/10 text-white/80',
        border: 'border border-white/20',
        icon: '👤',
        label: 'USUÁRIO',
        glow: '',
        textColor: 'text-white/70'
      };
  }
};

/**
 * Verifica se role deve ter destaque visual
 */
export const shouldHighlightRole = (role: RoleType): boolean => {
  return role === 'admin' || role === 'moderator';
};

/**
 * Retorna classe de animação baseada na role
 */
export const getRoleAnimation = (role: RoleType): string => {
  switch (role) {
    case 'admin':
      return 'animate-pulse';
    case 'moderator':
      return 'animate-pulse opacity-80';
    default:
      return '';
  }
};
